// eslint-disable-next-line complexity
const serializePractitioner = form => {
  const serialiazeMultipleValuesField = value => {
    if (Array.isArray(value)) return value.join(',');
    if (typeof value === 'string') return value;
    return '';
  };

  return {
    is_active: 1,
    practitioner_id: form.practitionerId,
    aligner_semester_price: form.alignerPrice.adult ?? null,
    aligner_supplier: serialiazeMultipleValuesField(form.alignerSupplier.name),
    avg_days_to_first_appointment: form.avgAppointmentDelay ?? null,
    crown_ceramic_min_price: form.ceramicCrownPrice.min ?? null,
    crown_ceramic_max_price: form.ceramicCrownPrice.max ?? null,
    uses_cerec_cfao: !!form.cerecCFAO,
    uses_optical_impression: !!form.opticalImpression,
    first_name: form.firstName || null,
    last_name: form.lastName || null,
    gender: form.gender?.[0]?.toUpperCase() ?? null,
    implant_min_price: form.implantPrice.min ?? null,
    implant_max_price: form.implantPrice.max ?? null,
    implant_supplier: serialiazeMultipleValuesField(form.implantSupplier.name),
    ortho_lab_supplier: serialiazeMultipleValuesField(form.orthoLabSupplier.name),
    ortho_semester_child_price: form.orthoPrice.child ?? null,
    ortho_semester_adult_price: form.orthoPrice.adult ?? null,
    prosthesis_supplier: serialiazeMultipleValuesField(form.prosthesisSupplier.name),
    is_general_practice: !!form.specialties.omniPractice,
    is_implantology: !!form.specialties.implantology,
    is_orthodontics: !!form.specialties.orthodontics,
    is_periodontics: !!form.specialties.periodontology,
    is_endodontics: !!form.specialties.endodontics,
    other_specialties: serialiazeMultipleValuesField(form.specialties.other)
  };
};

export default serializePractitioner;
